// SY11 메뉴 조회 — 2.0 GET /api/v1/system/menus (LOGISPRD-16595, MOMS_MENU_INFO). 페이지네이션 없음, 정렬은 BE(순서 단별 숫자 순).
import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import request from '@/utils/request'

export interface MenuRow {
  /** 수정·삭제(/{id}) 대상 식별자 — 2.0 응답 id. 화면 표시엔 미사용 */
  _id: number
  MENU_CD: string
  MENU_NM: string
  MENU_TYP: string
  MENU_TREE: string
  MENU_ORD: string
}

export interface MenuParams {
  menuCode?: string
  menuName?: string
}

interface MenuItem {
  id: number
  menuCode: string
  menuName?: string | null
  menuType?: string | null
  menuTree?: string | null
  menuOrder?: string | null
}

const toRow = (i: MenuItem): MenuRow => ({
  _id: i.id,
  MENU_CD: i.menuCode,
  MENU_NM: i.menuName ?? '',
  MENU_TYP: i.menuType ?? '',
  MENU_TREE: i.menuTree ?? '',
  MENU_ORD: i.menuOrder ?? '',
})

export const MENUS_PATH = '/api/v1/system/menus'

/** Query key — 맨 앞은 메뉴코드(탭 닫기 캐시 삭제). 무효화는 all, 조회는 list(params). */
export const menuQueryKeys = {
  all: ['sy11', 'getMenuList'] as const,
  list: (params: MenuParams) => [...menuQueryKeys.all, params] as const,
}

export const useGetMenuList = (params: MenuParams): UseQueryResult<MenuRow[], Error> =>
  useQuery({
    queryKey: menuQueryKeys.list(params),
    queryFn: async () => {
      const res = await request.get<ApiResponseV2<{ items: MenuItem[] }>, MenuParams>(MENUS_PATH, params)
      return (res.data?.items ?? []).map(toRow)
    },
  })
